import { apiGetStoreAvailability } from "../../api/getStoreAvailability";
import { apiGetPromotions } from "../../api/getPromotions";
import { BOOKING_STEPS } from "../../constants";
import { padNumberLeadingZero } from "../../utils";

export const BOOKING_PROCESS_SET_STEP = 'BOOKING_PROCESS_SET_STEP';
export const bookingProcessSetStep = step => ({ type: BOOKING_PROCESS_SET_STEP, step });

export const BOOKING_PROCESS_SET_PEOPLE = 'BOOKING_PROCESS_SET_PEOPLE';
export const bookingProcessSetPeople = numberOfPeople => ({ type: BOOKING_PROCESS_SET_PEOPLE, numberOfPeople });

export const BOOKING_PROCESS_PEOPLE_ADD = 'BOOKING_PROCESS_PEOPLE_ADD';
export const bookingProcessPeopleAdd = () => ({ type: BOOKING_PROCESS_PEOPLE_ADD });

export const BOOKING_PROCESS_PEOPLE_REMOVE = 'BOOKING_PROCESS_PEOPLE_REMOVE';
export const bookingProcessPeopleRemove = () => ({ type: BOOKING_PROCESS_PEOPLE_REMOVE });

export const BOOKING_PROCESS_TERMS_AND_PRIVACY_CLICKED = 'BOOKING_PROCESS_TERMS_AND_PRIVACY_CLICKED';
export const bookingProcessTermsAndPrivacyClicked = () => ({ type: BOOKING_PROCESS_TERMS_AND_PRIVACY_CLICKED });
export const BOOKING_PROCESS_SELECT_DATE = 'BOOKING_PROCESS_SELECT_DATE';
export const bookingProcessSelectDate = date => ({ type: BOOKING_PROCESS_SELECT_DATE, date });

export const BOOKING_PROCESS_SELECT_TIME = 'BOOKING_PROCESS_SELECT_TIME';
export const bookingProcessSelectTime = time => ({ type: BOOKING_PROCESS_SELECT_TIME, time });

export const STORE_AVAILABILITY_START_REQUEST = 'STORE_AVAILABILITY_START_REQUEST';
const storeAvailabilityStartRequest = date => ({ type: STORE_AVAILABILITY_START_REQUEST, date });

export const STORE_AVAILABILITY_REQUEST_RESULT = 'STORE_AVAILABILITY_REQUEST_RESULT';
const storeAvailabilityRequestResult = (date, lunchTimes, dinnerTimes) => ({
    type: STORE_AVAILABILITY_REQUEST_RESULT,
    date, lunchTimes, dinnerTimes,
});

export const STORE_AVAILABILITY_REQUEST_ERROR = 'STORE_AVAILABILITY_REQUEST_ERROR';
const storeAvailabilityRequestError = date => ({ type: STORE_AVAILABILITY_REQUEST_ERROR, date });

export const STORE_AVAILABILITY_RESET = 'STORE_AVAILABILITY_RESET';
// Reset the available times
export const storeAvailabilityReset = () => ({ type: STORE_AVAILABILITY_RESET });

export const BOOKING_PROCESS_RESET = 'BOOKING_PROCESS_RESET';
export const bookingProcessReset = () => ({ type: BOOKING_PROCESS_RESET });

export const bookingProcessSetDate = (date) => async (dispatch, getState) => {
    const state = getState();
    try {
        dispatch(bookingProcessSelectDate(date));

        // Before doing the request check if we already got the times for the date
        if (state.bookingProcessReducer.availableTimes[date]) {
            const times = state.bookingProcessReducer.availableTimes[date]
            if (!(!times.isFetching && times.error)) {
                return;
            }
        }

        dispatch(storeAvailabilityStartRequest(date));

        const store = state.storeReducer.stores[state.storeReducer.storeIdSelected];
        const response = await apiGetStoreAvailability(
            store.storeId,
            date,
            state.bookingProcessReducer.numberOfPeople
        );

        let lunchTimesStoreMin, lunchTimesStoreMax, dinnerTimesStoreMin, dinnerTimesStoreMax;

        if (store.lunchTimes) {
            lunchTimesStoreMin = new Date(`${date}T${store.lunchTimes.timeFrom}`);
            lunchTimesStoreMax = new Date(`${date}T${store.lunchTimes.timeLast}`);
        }

        if (store.dinnerTimes) {
            dinnerTimesStoreMin = new Date(`${date}T${store.dinnerTimes.timeFrom}`);
            const hourMaxDay = parseInt(store.dinnerTimes.timeLast.split(':')[0], 10);
            if (hourMaxDay <= 6) {
                const currentDay = new Date(date);
                currentDay.setDate(currentDay.getDate() + 1);
                dinnerTimesStoreMax = new Date(`${currentDay.getFullYear()}-${padNumberLeadingZero(currentDay.getMonth() + 1)}-${padNumberLeadingZero(currentDay.getDate())}T${store.dinnerTimes.timeLast}`);
            } else {
                dinnerTimesStoreMax = new Date(`${date}T${store.dinnerTimes.timeLast}`);
            }
        }

        const parsedDateTimeResponse = response.map(dateTime => ({
            timeParsed: new Date(`${dateTime.date}T${dateTime.time}`),
            time: dateTime.time,
        }));

        const lunchTimes = parsedDateTimeResponse.filter(parsedDateTime =>
            parsedDateTime.timeParsed <= lunchTimesStoreMax && parsedDateTime.timeParsed >= lunchTimesStoreMin);

        const dinnerTimes = parsedDateTimeResponse.filter(parsedDateTime =>
            parsedDateTime.timeParsed <= dinnerTimesStoreMax && parsedDateTime.timeParsed >= dinnerTimesStoreMin);

        dispatch(storeAvailabilityRequestResult(date, lunchTimes, dinnerTimes));
    } catch (error) {
        console.log(error);
        dispatch(storeAvailabilityRequestError(date));
    }
}

export const CHANGE_SERVICE_SELECTED = 'CHANGE_SERVICE_SELECTED';
export const changeServiceSelected = isServiceSelectedEvening => ({ type: CHANGE_SERVICE_SELECTED, isServiceSelectedEvening });

export const PROMOTIONS_START_REQUEST = 'PROMOTIONS_START_REQUEST';
const promotionsStartRequest = () => ({ type: PROMOTIONS_START_REQUEST });

export const PROMOTIONS_REQUEST_RESULT = 'PROMOTIONS_REQUEST_RESULT';
const promotionsRequestResult = promotions => ({ type: PROMOTIONS_REQUEST_RESULT, promotions });

export const PROMOTIONS_REQUEST_ERROR = 'PROMOTIONS_REQUEST_ERROR';
const promotionsRequestError = () => ({ type: PROMOTIONS_REQUEST_ERROR });

export const PROMOTION_SELECT = 'PROMOTION_SELECT';
export const promotionSelect = promotion => ({ type: PROMOTION_SELECT, promotion });

export const PROMOTION_RESET = 'PROMOTION_RESET';
export const promotionsReset = () => ({ type: PROMOTION_RESET });

export const PROMOTIONS_SET_EMPTY = 'PROMOTIONS_SET_EMPTY';
export const promotionsSetEmpty = (isEmpty = true) => ({ type: PROMOTIONS_SET_EMPTY, isEmpty });

export const promotionsGet = () => async (dispatch, getState) => {
    let { bookingProcessReducer: state, storeReducer, settingsReducer } = getState();
    if (state.areCurrentPromotionsValid) return;
    dispatch(promotionsStartRequest());
    try {
        const store = storeReducer.stores[storeReducer.storeIdSelected];
        const response = await apiGetPromotions(store.storeId, state.dateSelected, state.timeSelected, state.numberOfPeople, settingsReducer.language);
        // const response = {"TimeSlots":[{"TimeSlot":"2020-02-24T12:00:00.0000000","IsLeaveTimeRequired":false,"LeaveTime":"14:00:00","ServiceId":119179,"HasStandardAvailability":false,"AvailablePromotions":[{"Id":84600,"FeeAmount":150,"LeaveTime":"14:00:00","BasePrice":45},{"Id":82902,"FeeAmount":100,"LeaveTime":"14:00:00","BasePrice":22}],"StandardAvailabilityFeeAmount":0}],"Promotions":[{"Id":84600,"Name":"MENU ILHA BELA","Description":"Menu Ilha bela in italiano","MayRequireCreditCard":true,"MayRequireDeposit":false,"HorizontalImageUrl":"https://resdiary.blob.core.windows.net/uploads/uk/13928/images/20946/img90067.jpg","VerticalImageUrl":"","Translations":[{"LanguageCode":"it","Name":"MENU ILHA BELA","Description":"Menu Ilha bela in italiano"},{"LanguageCode":"en","Name":"Menu Ilha Bela","Description":"Menu in inglese"}],"PromotionTypeCodes":[],"ValidityPeriods":[{"StartDate":"2019-11-11T00:00:00.0000000","EndDate":"2027-11-11T00:00:00.0000000","StartTime":"12:00:00","EndTime":"13:30:00","Frequency":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday"],"IsAlwaysApply":false,"DayVariables":[{"DayOfWeek":"Sunday","Price":55},{"DayOfWeek":"Monday","Price":45},{"DayOfWeek":"Tuesday","Price":45}]}],"FullPrice":65,"PartySizeOperator":"Range","PartySizeLimit":0,"PartySizeMinCovers":10,"PartySizeMaxCovers":16,"LimitType":"None","MaxNumberOfSold":0},{"Id":82902,"Name":"MENU PELOURINHO","Description":"- MARESIA\n- ROLL SALMÃO GOSTOSO - 4 rolls\n- ROLL CAMARÃO ABACATE - 4 rolls\n- CAFFÈ\n\n--\n\nPer maggiori informazioni o assistenza alla prenotazione:\n+39 02 38236561","MayRequireCreditCard":true,"MayRequireDeposit":false,"HorizontalImageUrl":"https://resdiary.blob.core.windows.net/uploads/uk/13928/images/20946/img90062.jpg","VerticalImageUrl":"","Translations":[{"LanguageCode":"en-US","Name":"MENU PELOURINHO","Description":"- MARESIA\n- ROLL SALMÃO GOSTOSO - 4 rolls\n- ROLL CAMARÃO ABACATE - 4 rolls\n- CAFFÈ\n\n--\n\nPer maggiori informazioni o assistenza alla prenotazione:\n+39 02 38236561"}],"PromotionTypeCodes":[],"ValidityPeriods":[{"StartDate":"2019-11-11T00:00:00.0000000","EndDate":"2027-11-11T00:00:00.0000000","StartTime":"00:00:00","EndTime":"23:59:59","Frequency":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday"],"IsAlwaysApply":true,"DayVariables":[]}],"FullPrice":22,"PartySizeOperator":"Range","PartySizeLimit":0,"PartySizeMinCovers":10,"PartySizeMaxCovers":16,"LimitType":"None","MaxNumberOfSold":0}],"StandardAvailabilityMayRequireCreditCard":true}
        
        // If the user left the current step reset. This happens if the user changes step while the 
        // request is pending.
        let { bookingProcessReducer } = getState();
        if (bookingProcessReducer.currentStep !== BOOKING_STEPS.PROMOTION) {
            console.log('Resetting promotions step');
            return;
        }

        if (!response.Promotions || response.Promotions.length === 0) {
            dispatch(promotionsSetEmpty(true));
            dispatch(promotionSelect(null));
            return 'success';
        } else {
            const language = settingsReducer.language;
            const promotionsTranslated = response.Promotions.map(promotion => {
                if (!promotion.Translations) {
                    return { 
                        Name: promotion.Name, 
                        Description: promotion.Description, 
                        Id: promotion.Id, 
                        FullPrice: promotion.FullPrice 
                    }
                }
                const translated = promotion.Translations.find(translation => translation.LanguageCode.indexOf(language) !== -1);
                if (!translated) {
                    return { 
                        Name: promotion.Name, 
                        Description: promotion.Description, 
                        Id: promotion.Id, 
                        FullPrice: promotion.FullPrice 
                    }
                } else {
                    return {
                        Name: translated.Name, 
                        Description: translated.Description, 
                        Id: promotion.Id, 
                        FullPrice: promotion.FullPrice 
                    }
                }
            });

            // Refactor the promotion object
            const promotionsToSave = promotionsTranslated.map(p => {
                let description = p.Description;
                if (description && typeof description === 'string') {
                    description = description.replace(/\n/g, "<br />");
                }
                return {
                    id: p.Id, name: p.Name,
                    description,
                    promotionPrice: p.FullPrice,
                }
            });

            // Check if the selected promotion id is still valid, if not reset it
            const currentSelectedPromotionId = state.promotionSelected;
            if (currentSelectedPromotionId) {
                const found = promotionsToSave.find(p => p.id === currentSelectedPromotionId);
                if (!found) {
                    dispatch(promotionSelect(null));
                }
            }

            dispatch(promotionsRequestResult(promotionsToSave));
            return 'success';
        }
    } catch (error) {
        console.log(error);
        dispatch(promotionsRequestError());
    }
}

export const PERSONAL_DATA_SET_FIELDS = 'PERSONAL_DATA_SET_FIELDS';
export const personalDataSetFields = ({
    name, surname, mobilePhone, email, hasAcceptedEmailMarketing, specialRequests, mobilePhoneCountryData
}) => ({
    type: PERSONAL_DATA_SET_FIELDS, name, surname, mobilePhone, email, hasAcceptedEmailMarketing, 
    specialRequests, mobilePhoneCountryData
});

export const SET_IS_EDITING_BOOKING = 'SET_IS_EDITING_BOOKING';
export const setIsEditingBooking = isEditing => ({ type: SET_IS_EDITING_BOOKING, isEditing });


// WEBPACK FOOTER //
// ./src/store/actions/bookingProcess.js